import $ from 'jquery';
import 'jquery.cookie';

import { InitUI as GlobalInitUI, IsDesktopSite, sendGeolocationData } from 'global/GlobalUI.js';

import 'global/PushNotifications.js';
import { IsMobile, setCookie } from 'global/BrowserUtil.js';
import { btnDivAlerta, btnVerifyAccountStep1 } from 'account/AgeVerification.js';
import { getAccNoFromUV } from 'account/Index.js';
import { IovationChunk } from 'global/Chunks.js';
import { BetLegSuspend } from 'betting/BetSlipSelections.js';
import { SetupEarlyPayoutPopup } from 'sports/Signposting';
import { LaunchGame } from 'navigation/QuickLinks.js';
import { SubscribeToPromotion as SubscribeToPopupPromotion } from 'promotions/Index.js';
import { Init as BetmateInitialization } from 'betmate/Index.js';

import { InitWebsocket } from 'global/WebSocket';

import MobileAPI from 'app/MobileApi.js';
import MobileApp from 'app/MobileApp.js';
import { GenerateStorylyTags, InitializeStorylyTag, ExecuteQubitCallback } from 'storyly/Index.js';
//playtech API
//https://login-games.boylesports.com/jswrapper/integration.js.php?casino=boylesports
import 'external/integration.js';

//CSS
import 'css/base.scss';
import "slick-carousel/slick/slick.scss";
import "css/modules.style.scss";
import "css/media-queries.style.scss"; 
/**
 * INIT CODE
 * Use this section for page load code that should be run
 */

async function InitMobileAPI() {
    let isMobile = IsMobile();
    let mobileApp = new MobileApp(navigator.userAgent, isMobile, '');
    let mobileApi = new MobileAPI(mobileApp.isMobile, mobileApp.isIOS, mobileApp.isAndroid);
    mobileApi.SetLoginSessionInfo(window.ModuleConfig.LoginSessionInfo);

    $(function () {
        if (window.location.href.toLowerCase().indexOf("mobilesportsbook/promotions") > -1) {
            mobileApp.setActiveFooterTab('promotions');
            mobileApp.callNativeApp('app_OpenPulsateMenu');
        }
    });
    $(document).on("touchend", "#login-funnel .close-funnel", function (e) {
        e.preventDefault();
        mobileApp.checkIsLoginPopup();
        $('.withdivAVpopup').css('display', '');
        $('#AVDialogStep1').css('display', 'none');
    });

    window.mobileApp = mobileApp;
    window.mobileApi = mobileApi;
}

$(window).on("orientationchange", function () {
    var isIOS = navigator.userAgent.match(/iPhone|Ipad/i) != null;
    if (isIOS) {
        $('.scroll_wrapper#racing-nav').css('width', '100%');
        $('.scroll_wrapper.minimenu-nav').css('width', '100%');
        $('.scroll_wrapper#inplayMenu').css('width', '100%');
    }
});

function InitUV() {
    window.universal_variable = window.universal_variable || {};
    window.universal_variable.page = window.universal_variable.page || {};
    window.universal_variable.user = window.universal_variable.user || {};
    window.universal_variable.basket = window.universal_variable.basket || {};
    window.universal_variable.basket.line_items = window.universal_variable.basket.line_items || [];
    window.universal_variable.basket.total_stake = 0;
    window.universal_variable.basket.total_potential = 0;
    window.universal_variable.basket.tax = 0;
    window.universal_variable.basket.total_bet_number = window.universal_variable.basket.line_items.length;
    window.universal_variable.events = window.universal_variable.events || [];
    window.universal_variable.page = {
        "category": "home",
        "subcategory": "sports-betting",
        "environment": "production"
    };
    if (window.ModuleConfig.LoginSessionInfo.username === null) {
        window.universal_variable.user = {
            "language": "en-gb"
        };
    } else {
        window.universal_variable.user = {
            user_id: window.ModuleConfig.LoginSessionInfo.user_id,
            language: "en-gb",
            account_currency: window.ModuleConfig.LoginSessionInfo.acc_currency_name,
            avstatus: window.ModuleConfig.LoginSessionInfo.avstatus,
            username: window.ModuleConfig.LoginSessionInfo.username,
            firstname: window.ModuleConfig.LoginSessionInfo.firstname,
            holder_id: window.ModuleConfig.LoginSessionInfo.user_account_id,
            acc_no: window.ModuleConfig.LoginSessionInfo.acc_no,
            risk_category: window.ModuleConfig.LoginSessionInfo.risk_category,
            bet_factor: window.ModuleConfig.LoginSessionInfo.bet_factor,
            IdCustomer: window.ModuleConfig.LoginSessionInfo.customer_id,
            currency_notation: window.ModuleConfig.LoginSessionInfo.acc_currency,
            odds_type: window.ModuleConfig.LoginSessionInfo.odds_type,
            email: window.ModuleConfig.LoginSessionInfo.email
        };

    }
}

function InitEGUV() {
    if (window.uv == null) {
        return;
    }
    window.egUser = function () {
        dataLayer.push({
            event: 'egUser',
            egUser: window.__eg_user
        });
    };
    window.egUser();

    window.egUserLogin = function () {
        localStorage.removeItem('FireLoginEvent');
        window.uv.emit('egUserLogin', {
            firstLogin: window.__eg_user.firstSession,
            type: "Password",
            user: window.__eg_user
        });
    };

    window.egUserSignUp = function () {
        localStorage.removeItem('FireRegistrationEvent');
        window.uv.emit('egUserSignup', {
            type: "Registration",
            name: "Account_Registration",
            user: window.__eg_user
        });
    };


    if (localStorage.getItem('FireLoginEvent')) {
        window.egUserLogin();
    }
    if (localStorage.getItem('FireRegistrationEvent')) {
        window.egUserSignUp();
    }
}

const FeatureFlags = {
    None: 0,
    Preload: 1,
    Prefetch: 2,
    Nomodule: 4 //4
}

function SetFeatureFlags() {
    let flags = 0;

    try {
        var relList = document.createElement('link').relList;

        if (!!(relList && relList.supports)) {
            if (!!(relList.supports('preload'))) {
                flags |= FeatureFlags.Preload;
            }
            if (!!(relList.supports('prefetch'))) {
                flags |= FeatureFlags.Prefetch;
            }
        }

        if ('noModule' in HTMLScriptElement.prototype)
            flags |= FeatureFlags.Nomodule;
    }
    catch (e) {
        console.error(e);
    }

    setCookie("FeatureFlags", flags, 1);
}
/**
 * EXPORTS TO WINDOW HERE
 * Use this section to set global window functions.
 * This is the gatekeeper to keep track of whats used externally on the pages
 * DO NOT ADD WINDOW FUNCTIONS FROM INSIDE YOUR MODULES AND CALL THEM FROM HTML
 * THEY MUST BE SET HERE!!
 * 
 * Example:
 * w.AppCode = {
 *  Run: MyModule.Run
 * }
 * 
 * This will allow you to call window.AppCode.Run() externally (or simply AppCode.Run())
 */

window.$ = window.jQuery = $; //export jQuery function to window
if (typeof window.ModuleConfig.gws !== "string" || (typeof window.ModuleConfig.gws === "string" && window.ModuleConfig.gws.length === 0)) {
    window.ModuleConfig.gws = 'ws1.boylesports.com'; //used to pass Web.config values to JS modules here
}
window.decimal = false; //show decimal odds
window.Sports = {};

window.getAccNoFromUV = getAccNoFromUV;
window.SetupEarlyPayoutPopup = SetupEarlyPayoutPopup;

/**
 * Functions used by qubit scripts
 */
window.btnDivAlerta = btnDivAlerta;
window.BetLegSuspend = BetLegSuspend;
window.btnVerifyAccountStep1 = btnVerifyAccountStep1;
window.LaunchGame = LaunchGame;
window.SubscribetoPromotion = SubscribeToPopupPromotion;
window.InitializeStorylyTag = InitializeStorylyTag;
window.GenerateStorylyTags = GenerateStorylyTags;
window.ExecuteQubitCallback = ExecuteQubitCallback;
/**
 * RUN INIT CODE
 */
window.addEventListener('DOMContentLoaded', GlobalInitUI);
//SetFeatureFlags();
InitWebsocket();
InitMobileAPI();
InitUV();
InitEGUV();
BetmateInit();
 
 
if ((window.mobileApp.isIOS || window.mobileApp.isAndroid) && window.ModuleConfig.LoginSessionInfo.user_id != null && window.SaveGeolocation?.toLowerCase() == "true" && window.EnableSaveGeolocation?.toLowerCase() == "true") {
    getGeo(); 
}
else if (window.mobileApp.isMobile && window.ModuleConfig.LoginSessionInfo.user_id != null && window.SaveGeolocation?.toLowerCase() == "true" && window.EnableSaveGeolocation?.toLowerCase() == "true")
{ 
    const Device = "Mobile";
    sendGeolocationData({ Device });
}
async function getGeo() {
    let geoSuccess = false;
    const Device = window.mobileApp.isIOS ? "IOS" : "Android";
    try {
        const response = await window.mobileApi.GetGeoLocation();
        geoSuccess = true;
        const DataObject = (response.error_msg && response.error_code)
            ? { Device }
            : {
                Latitude: response.lat,
                Longitude: response.lng,
                ISOCode: response.iso_code,
                ISOCode2: response.iso_code_2,
                Country: response.country,
                DateTimeStamp: response.timestamp,
                Device
            };

        sendGeolocationData(DataObject);
    } catch (error) {
        geoSuccess = false; 
    }

    if (!geoSuccess) {
        //fallback: geosuccess is still false;
        sendGeolocationData({ Device });
    }
}

function BetmateInit() {
    var path = window.location.pathname.toLowerCase();
    if (path.includes('/free-to-play')) {
        BetmateInitialization();
    }
}




